import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import DetectPage from '@/spa/pages/DetectPage'
import { routeErrorComponent } from './_shared/RouteError'

// Search params on /detect:
//   rerun — analysis id to re-run. DetectPage reads the row from the local
//   SQLite mirror and prefills the page. Replaces the old sessionStorage
//   handshake (lost on tab close, hit base64 quota on big images).
const Search = z.object({
  rerun: z.string().uuid().optional(),
  // camera — when truthy, DetectPage auto-opens the camera viewfinder once
  // and strips the param (set by the history-detail "Zur Kamera" button).
  // z.coerce: tolerant of the param arriving as boolean true or string "true".
  camera: z.coerce.boolean().optional(),
})

export const Route = createFileRoute('/detect')({
  validateSearch: Search.parse,
  component: DetectPage,
  errorComponent: routeErrorComponent,
})
